import { Image } from 'antd-mobile'
import { AddSquareOutline } from 'antd-mobile-icons'
import { isEmpty } from 'lodash-es'
import { cloneDeep } from 'lodash-es'
import { toJS } from 'mobx'
import { observer, useLocalObservable } from 'mobx-react-lite'
import React, { useEffect } from 'react'

import {
  updateFormItems,
  analyzeFormFields,
  contentName
} from '@/components/NewEditForm/UILibrary/HYBElement/BlockLevel/BlockLevelForm/utils'
import jobStore from '@/store/components/entryJob'

import { HBlockAdd } from '../../HYBVant'

import Popup from './Popup'

import './index.less'
import useLocalRewardPunishment from './useLocalRewardPunishment'
import useRewardPunishment from './useRewardPunishment'

interface IUniversalRecord {
  onConfirm?: (data: any) => void
  isLocalObserver?: boolean
  publicForm?: any
  isAuth?: boolean
  value?: any
  belongCode?: any
  title?: any
  staffId?: any
}
const UniversalRecord: React.FC<IUniversalRecord> = ({
  onConfirm,
  isLocalObserver,
  title,
  staffId,
  belongCode,
  publicForm = [],
  isAuth = true,
  value
}) => {
  const { employeeIds } = useLocalObservable(() => jobStore)
  console.log(belongCode, 'publicForm', publicForm)
  const local = useLocalRewardPunishment({
    onConfirm,
    employeeIds,
    value
  })
  const remote = useRewardPunishment({
    onConfirm,
    employeeIds,
    value
  })
  const {
    add,
    edit,
    open,
    modalData,
    onCancel,
    runSaveDynamicFielDetail,
    runDeleteDynamicFielDetail,
    hrmDynamicFielDetailLoading,
    deleteDynamicFielDetailLoading
  } = isLocalObserver ? local : remote
  const { formInfos } = updateFormItems({
    dynamicBasisForm: publicForm,
    bool: !isAuth,
    islist: true
  })
  const list = cloneDeep(publicForm?.[0]?.form_list || [])
  const len = list.length
  const bool_ = len > 1
  const { name, type, name_note, type_note } = analyzeFormFields(list)
  return (
    <div className='health_certificate'>
      {!isEmpty(value) && (
        <div className='health_certificate-content-wrapper'>
          {value?.map((x: any, index: number) => (
            <div
              key={x}
              className='health_certificate-content'
              onClick={() => isAuth && edit(index)}
            >
              <div className='health_certificate-content-col-1'>
                <div className='health_certificate-content-1'>
                  {name ? contentName(x, name, type) : '-'}
                </div>
                <div className='health_certificate-content-3'>
                  {name && bool_ ? contentName(x, name_note, type_note) : ''}
                </div>
              </div>
              <div className='health_certificate-content-col-2'>
                {isAuth && (
                  <Image
                    className='hyb-com-concat-content-col-2-img'
                    src='https://s.huiyunban.cn/1747191709529280512.png'
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      {isAuth && <HBlockAdd onClick={add} text={`添加${title || ''}`} />}
      {open && (
        <Popup
          visible={open}
          title={title || ''}
          onCancel={onCancel}
          belongCode={belongCode}
          formInfo={formInfos || []}
          publicForm={publicForm}
          modalData={{
            ...modalData,
            runSaveDynamicFielDetail,
            runDeleteDynamicFielDetail,
            hrmDynamicFielDetailLoading,
            deleteDynamicFielDetailLoading
          }}
        />
      )}
    </div>
  )
}

export default observer(UniversalRecord)
